import * as React from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { isEqual } from "lodash";

import { useBreakpoint } from "../../hooks/useBreakpoint";
import { useXoraiaValue } from "../../hooks/useXoraia";
import { TUseXElement, useXElement } from "../../hooks/useXElement";
import { USE_SELECTED_INDEX } from "../../hooks/useSelectedElement";
import { useSetRecoilState } from "recoil";
import { getValueOnBreakpoint } from "../../lib/getValueOnBreakpoint";
import { clickHandler } from "../../lib/clickHandler";
import { XElementConfig } from "../../utils/interfaces/Elements/XElement.interfaces";
import { generateSide } from "../../lib/generateSide";
import {
  IXBreadcrumbProps,
  XBreadcrumbProps,
} from "../../utils/interfaces/Elements/XBreadcrumb.interfaces";
import { generateBorder } from "../../lib/generateBorder";
import { generateRadius } from "../../lib/generateRadius";
import { HomeOutlined } from "@mui/icons-material";

const compareProps = (prevProps: any, nextProps: any) => {
  return isEqual(prevProps, nextProps);
};

const XBreadcrumb: React.FC<XBreadcrumbProps> = React.memo(
  ({ config = {} as XElementConfig }) => {
    // WE TRACK THE BREAK POINTS CHANGES
    const breakpoint = useBreakpoint();

    const { env, Link: XLink } = useXoraiaValue();

    // WE ARE GETTING THE CURRENT ELEMENT FROM THE ATOM FAMILY
    const { xElement } = useXElement<TUseXElement<IXBreadcrumbProps>>(
      config.index
    );

    // GARBING THE INDEX UPDATER FOR GENERAL USAGE
    const setSelectedElement = useSetRecoilState(USE_SELECTED_INDEX);

    // IF WE DONT HAVE THIS ELEMENT CONFIGS ADDED WE DON'T SHOW IT
    if (!xElement || Object.keys(xElement).length === 0) return null;

    // WE GET ALL DEVICES PROPS AS VALUE
    const { value } = xElement;

    // WE NOW USE THE CURRENT BREAKPOINT VALUE ON THIS ELEMENT
    const valueAtBreakPoint = getValueOnBreakpoint<IXBreadcrumbProps>(
      value as any,
      breakpoint
    );

    const devProps = {
      id: config.index,
      onClick: (e: any) => clickHandler(e, setSelectedElement, config.index),
    };

    const {
      // path = "/categories/[slug]",
      separator = "/",
      bgColor,
      border,
      borderRadius,
      fontFamily,
      fontSize,
      linkColor,
      linkDecoration,
      linkHoverColor,
      linkHoverDecoration,
      showHomeIcon,
      showHomeLabel = true,
      textColor,
      // showHomeIcons = false,
      // showHomeLabel = true,
      width,
      height,
      padding,
      margin,
      // TODO IMPLEMENT BORDER RADIUS
    } = valueAtBreakPoint;

    return (
      <Breadcrumbs
        {...(env === "dev" && devProps)}
        separator={separator}
        sx={{
          alignItems: "center",
          ...valueAtBreakPoint,
          padding: generateSide("padding", padding),
          margin: generateSide("margin", margin),
          width,
          height,
          bgcolor: bgColor,
          border: generateBorder(border),
          borderRadius: generateRadius(borderRadius),
          fontFamily,
          fontSize,
          color: textColor,

          "& a": {
            color: linkColor,
            textDecoration: linkDecoration ?? "none",

            "&:hover": {
              color: linkHoverColor,
              textDecoration: linkHoverDecoration,
            },
          },
        }}
      >
        <Link
          component={XLink}
          href="/"
          sx={{ display: "flex", alignItems: "center" }}
        >
          {showHomeIcon && <HomeOutlined sx={{ fontSize: "inherit" }} />}
          {showHomeLabel && (
            <Typography
              component="span"
              ml={showHomeIcon ? 0.5 : 0}
              sx={{
                fontSize: "inherit",
                color: "inherit",
                fontWeight: "inherit",
                fontFamily: "inherit",
              }}
            >
              Home
            </Typography>
          )}
        </Link>
        <Link component={XLink} href="/page">
          Page 1
        </Link>
        <Typography
          sx={{
            fontSize: "inherit",
            color: "inherit",
            fontWeight: "inherit",
            fontFamily: "inherit",
          }}
        >
          Page 2
        </Typography>
      </Breadcrumbs>
    );
  },
  compareProps
);

export default XBreadcrumb;
